
import { List } from 'antd-mobile'
import { ConditionCheckListItem } from './ConditionCheckListItem'
import "static/css/serviceApply.css"

/**处理list具体事项 */
const ConditionCheckList = ({ list, onItemChange }) => {
  const item = list[0] || []
  if (!item) return null
  const { systemConditions, personalConditions, otherConditions } = item || {}
  const titleList = [
    { title: '系统判断条件（需同时满足）', list: systemConditions, valueName: 'requirement', disabled: true, type: 'systemConditions' },
    { title: '个人判断条件（需同时满足）', list: personalConditions, valueName: 'requirement', disabled: false, type: 'personalConditions' },
    { title: '其他判断条件（满足以下其一即可）', list: otherConditions, valueName: 'requirement', disabled: false, type: 'otherConditions' },
  ]
  return titleList.map((titleItem, index) => {
    const { title, list } = titleItem
    return (
      <div key={index}>
        {
          list.length > 0 &&
          (
            <List header={title}>
              {
                list.map((item, index) => {
                  const { id } = item
                  return (
                    <ConditionCheckListItem
                      key={id || index}
                      item={item}
                      titleItem={titleItem}
                      onItemChange={onItemChange}
                    />
                  )
                })
              }
            </List>
          )
        }
      </div>
    )
  })
}

export { ConditionCheckList }